import ResizeContainer from './ResizeContainer.vue'

export default ResizeContainer
